import { TPropertyStatus } from "../typos/properties";

// eslint-disable-next-line import/prefer-default-export
export const PropertyStatusLabel: Record<TPropertyStatus, string> = {
  WAITING_FOR_APPROVAL: "En análisis",
  ACTIVE: "Activo",
  PAUSED_BY_USER: "Pausado",
  PAUSED_BY_APPLICATION: "Pausado por Tuhogar",
  INACTIVE: "Inactivo",
};
